import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Typography,
} from "@mui/material";
import ScreenLoader from "../../component/screenLoader";
import axios from "../../axios/index";
import debounce from "lodash/debounce";
import ReturnTimeModal from "../../component/modal/returnTime";
import SearchField from "../../component/searchField";

export default function AssigneBikes() {
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [totalRows, setTotalRows] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [searchQuery, setSearchQuery] = React.useState(""); // State for search query
  const [loader, setLoader] = React.useState(true);
  const columns = [
    { field: "id", headerName: "No", flex: 0 },
    { field: "name", headerName: "Name", flex: 2 },
    { field: "bikes", headerName: "Bikes", flex: 2 },
    { field: "size", headerName: "Size", flex: 0 },
    { field: "assignDate", headerName: "Assigned Date", flex: 2 },
    { field: "assignTime", headerName: "Assigned Time", flex: 2 },
    { field: "returnDate", headerName: "Return Date", flex: 2 },
    { field: "returnTime", headerName: "Return Time", flex: 2 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        return params?.row?.returnTime != "-" ? (
          "-"
        ) : (
          <ReturnTimeModal id={params?.row?.id} setRows={setRows} />
        );
      },
    },
  ];

  const fetchData = async (searchText = "") => {
    axios
      .get(
        `/assign-bikes?page=${
          page + 1
        }&pageSize=${pageSize}&search=${searchText}`
      )
      .then((res) => {
        console.log(res);
        // Transform the received data into the desired format
        const transformedData = res?.data?.data?.map((item) => ({
          id: item._id,
          name: `${item?.user[0]?.firstName} ${item?.user[0]?.lastName}`,
          bikes: item?.bike[0]?.name,
          size: item?.size[0]?.variant,
          assignDate: new Date(item?.createdAt).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          }),
          assignTime: new Date(item?.createdAt).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          }),
          returnDate: item?.returnTime
            ? new Date(item?.returnTime).toLocaleTimeString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            : "-",
          returnTime: item?.returnTime
            ? new Date(item?.returnTime).toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })
            : "-",
        }));

        setRows(transformedData);
        setTotalRows(res?.data?.totalRecords);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    setPage(newPage?.page);
  };

  // Define a debounce delay (e.g., 300 milliseconds)
  const debounceDelay = 1000;

  // Create a debounced search function
  const debouncedSearch = debounce((searchText = "") => {
    fetchData(searchText);
  }, debounceDelay);

  // Handle search input change
  const handleSearchChange = (event) => {
    let searchText = event.target.value;
    setPage(0); // Reset to the first page when searching
    setSearchQuery(searchText);
    if (!searchText || searchText == "") {
      debouncedSearch();
    } else if (searchText.length >= 3) {
      debouncedSearch(searchText);
    }
  };

  // Initial data fetch
  React.useEffect(() => {
    fetchData();
  }, [page, pageSize]);

  if (loader) {
    return <ScreenLoader />;
  }

  return (
    <Box
      sx={{
        height: "100vh",
        pt: "198px",
        pb: "150px",
        pl: "40px",
        pr: "45px",
        background: "#fff",
      }}
    >
      <Typography
        sx={{ color: "#081225", fontSize: "32px", fontWeight: 500, mb: "11px" }}
        component="h3"
      >
        Assigned Bike’s
      </Typography>
      <Box
        sx={{
          mb: "30px",
        }}
      >
        <SearchField value={searchQuery} onChange={handleSearchChange} />
      </Box>
      <div style={{ width: "100%", height: 400 }}>
        {/* <InputField placeholder="Write text...." onChange={handleSearchChange}/> */}
        <DataGrid
          sx={{
            borderRadius: "20px",
            ".css-t89xny-MuiDataGrid-columnHeaderTitle": {
              fontSize: "16px",
              fontWeight: 400,
              color: "#2F2F2F",
            },
            ".css-19p8xgs-MuiDataGrid-root .MuiDataGrid-cellContent": {
              fontSize: "16px",
              fontWeight: 400,
              color: "#1F1F1F",
            },
            ".MuiDataGrid-withBorderColor": {
              pl: "10px",
            },
            ".MuiDataGrid-cell": {
              pl: "20px !important",
            },
          }}
          initialState={{
            pagination: {
              paginationModel: { page: page, pageSize: pageSize },
            },
          }}
          rows={rows?.length ? rows : []}
          columns={columns}
          pagination
          pageSize={pageSize}
          rowCount={totalRows}
          paginationMode="server"
          onPaginationModelChange={handlePageChange}
          pageSizeOptions={[10]}
        />
      </div>
    </Box>
  );
}
